import { EduService } from "./EduService";
export default EduService;
